export default [
  {
    offset: [0.11, 0.04],
    size: [250, 250],
    scroll: 0.212,
    type: 'deals',
    x: 0.489,
    y: 0.701
  },
  {
    offset: [0.01, 0.06],
    size: [300, 250],
    scroll: 0.431,
    type: 'shop',
    x: 0.494,
    y: 0.176
  },
  {
    name: 'doodle-jump',
    offset: [0.1, 0.25],
    size: [250, 350],
    type: 'game',
    scroll: 0.5,
    x: 0.292,
    y: 0.442
  },
  {
    name: 'jump-and-run',
    offset: [0.075, 0.1],
    size: [380, 200],
    scroll: 0.552,
    type: 'game',
    x: 0.821,
    y: 0.222
  },
  {
    name: 'tap-and-smash',
    offset: [-0.02, 0.2],
    size: [225, 300],
    type: 'game',
    scroll: 0.5,
    x: 0.657,
    y: 0.633
  }
];
